
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/_work/monorepo/monorepo/frontend/marketplace/sentry.client.config.ts")
            }
          });